import { render, staticRenderFns } from "./RelatedRulesModal.vue?vue&type=template&id=8b46e254&"
import script from "./RelatedRulesModal.vue?vue&type=script&lang=js&"
export * from "./RelatedRulesModal.vue?vue&type=script&lang=js&"
import style0 from "./RelatedRulesModal.vue?vue&type=style&index=0&id=8b46e254&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports